import React, { useEffect, useState, useMemo } from "react";
import {
  getInitiativeById,
  getDepartmentOwners,
} from "../../../../api/initiative";
import CompanyDashboardInitiativeDrawerHeader from "./company-dashboard-initiative-drawer-header/company-dashboard-initiative-drawer-header";
import CompanyDashboardInitiativeDrawerSideBar from "./company-dashboard-initiative-drawer-side-bar/company-dashboard-initiative-drawer-side-bar";
import CompanyDashboardInitiativeMilestones from "./company-dashboard-initiative-drawer-milestones/company-dashboard-initiative-drawer-milestones";
import CompanyDashboardAddInitiativeDisposition from "./company-dashboard-initiative-add-drawer-disposition/company-dashboard-initiative-add-drawer-disposition";
import CompanyDashboardInitiativeAddIssue from "./company-dashboard-initiative-add-drawer-issue/company-dashboard-initiative-add-drawer-issue";
import { useSetLoading } from "../../../../common/hooks/appearance";
import "./company-dashboard-initiative-add-drawer.scss";

const CompanyDashboardInitiativeAddDrawer: any = (props: any) => {
  const {
    setIsShowInitiativeDrawer,
    employeesList,
    setAlertMessage,
    setAlertType,
    setAlertOpen,
    initiativeId,
    setInitiativeId,
    objectiveId,
    setObjectiveId,
    keyResultId,
    setKeyResultId,
    fetchInitiatives,
    statusListKeyResults,
    statusListObjectives,
    statusListInitiatives,
    fetchUpcomingMilestones,
    setObjective,
    setIsShowAddAllObjectiveDrawer,
    fetchAllYearsForInitiatives,
    fetchAllYearsForObjectives,
  } = props;
  const [initiativeAPIData, setInitiativeAPIData] = useState<any>(null);
  const [milestonesData, setMilestonesData] = useState([]);
  const [departmentsList, setDepartmentsList] = useState<any>([]);
  const [initiativeLoading, setInitiativeLoading] = useState<any>(true);
  const [departmentOwnersLoading, setDepartmentOwnersLoading] =
    useState<any>(true);
  const [loading, setLoading] = useState<any>(true);
  const [initiativeDataPermissions, setInitiativeDataPermissions] =
    useState<any>(null);
  const userDetails = JSON.parse(localStorage.getItem("userDetails") || "{}");
  const userId = userDetails?.employeeId;
  const [clearedMilestonesData] = useState<any[]>([]);

  const showLoading = useMemo(
    () => loading || initiativeLoading || departmentOwnersLoading,
    [loading, initiativeLoading, departmentOwnersLoading],
  );
  useSetLoading(showLoading);

  const handlePermissionData = (data: any) => {
    const isCreator =
      data?.owners?.map((owner: any) => owner.ownerId)?.includes(userId) ||
      userDetails?.roles?.find((role: any) => role?.name === "Admin");

    setInitiativeDataPermissions(isCreator);
  };

  const fetchInitiativeById = async (updatedInitiativeId?: any) => {
    setInitiativeLoading(true);
    try {
      const response = await getInitiativeById(
        updatedInitiativeId || initiativeId,
      );
      setInitiativeAPIData(response?.data?.data);
      handlePermissionData(response?.data?.data);
      setTimeout(() => setInitiativeLoading(false), 0);
    } catch (error: any) {
      setAlertMessage(
        error?.response?.data?.message || "Failed to fetch initiative",
      );
      setAlertType("error");
      setAlertOpen(true);
      setInitiativeLoading(false);
    }
  };

  const fetchDepartmentOwners = async () => {
    setDepartmentOwnersLoading(true);
    try {
      const response = await getDepartmentOwners();
      setDepartmentsList(response?.data?.data);
      setTimeout(() => setDepartmentOwnersLoading(false), 0);
    } catch (error: any) {
      setAlertMessage(
        error?.response?.data?.message || "Failed to fetch initiative",
      );
      setAlertType("error");
      setAlertOpen(true);
      setDepartmentOwnersLoading(false);
    }
  };
  useEffect(() => {
    if (initiativeId) {
      fetchInitiativeById();
      fetchDepartmentOwners();
    } else {
      setInitiativeLoading(false);
      setDepartmentOwnersLoading(false);
      setLoading(false);
    }
  }, [initiativeId]);

  return (
    <div className="company-dashboard-initiative-drawer">
      <div className="company-dashboard-initiative-drawer-content">
        <CompanyDashboardInitiativeDrawerHeader
          setIsShowInitiativeDrawer={setIsShowInitiativeDrawer}
          isShowMsg={
            !!(
              initiativeAPIData?.evaluatedStatus ===
                "In Progress - Off Track" ||
              initiativeAPIData?.evaluatedStatus === "In Progress - At Risk"
            )
          }
          isShowSuccessMsg={
            initiativeAPIData?.evaluatedStatus === "In Progress - On Track"
          }
          fetchInitiatives={fetchInitiatives}
          fetchUpcomingMilestones={fetchUpcomingMilestones}
          fetchAllYearsForInitiatives={fetchAllYearsForInitiatives}
          fetchAllYearsForObjectives={fetchAllYearsForObjectives}
        />
        <div className="company-dashboard-initiative-drawer-content-body">
          <div className="company-dashboard-initiative-drawer-content-body-section">
            <div className="company-dashboard-initiative-drawer-content-body-section-left">
              <CompanyDashboardInitiativeDrawerSideBar
                setIsShowInitiativeDrawer={setIsShowInitiativeDrawer}
                employeesList={employeesList}
                setInitiativeId={setInitiativeId}
                initiativeId={initiativeId}
                fetchInitiativeById={fetchInitiativeById}
                setAlertType={setAlertType}
                setAlertOpen={setAlertOpen}
                setLoading={setLoading}
                setAlertMessage={setAlertMessage}
                objectiveId={objectiveId}
                setObjectiveId={setObjectiveId}
                keyResultId={keyResultId}
                setKeyResultId={setKeyResultId}
                initiativeAPIData={initiativeAPIData}
                fetchInitiatives={fetchInitiatives}
                statusListKeyResults={statusListKeyResults}
                statusListObjectives={statusListObjectives}
                statusListInitiatives={statusListInitiatives}
                setObjective={setObjective}
                setIsShowAddAllObjectiveDrawer={setIsShowAddAllObjectiveDrawer}
                departmentsList={departmentsList}
                milestonesData={milestonesData}
                setMilestonesData={setMilestonesData}
                clearedMilestonesData={clearedMilestonesData}
                initiativeDataPermissions={initiativeDataPermissions}
              />
            </div>
            <div
              className={`company-dashboard-initiative-drawer-content-body-section-right  ${initiativeId ? "" : "not-allowed-section"}`}
            >
              <div
                className={`company-dashboard-initiative-drawer-content-body-section-right-section-one`}
                style={{ pointerEvents: initiativeId ? "auto" : "none" }}
              >
                <CompanyDashboardAddInitiativeDisposition
                  initiativeId={initiativeId}
                  initiativeAPIData={initiativeAPIData}
                  employeesList={employeesList}
                  fetchInitiativeById={fetchInitiativeById}
                  fetchInitiatives={fetchInitiatives}
                  setAlertType={setAlertType}
                  setAlertOpen={setAlertOpen}
                  setLoading={setLoading}
                  setAlertMessage={setAlertMessage}
                  initiativeDataPermissions={initiativeDataPermissions}
                />
                <CompanyDashboardInitiativeAddIssue
                  initiativeId={initiativeId}
                  initiativeAPIData={initiativeAPIData}
                  employeesList={employeesList}
                  fetchInitiativeById={fetchInitiativeById}
                  fetchInitiatives={fetchInitiatives}
                  setAlertType={setAlertType}
                  setAlertOpen={setAlertOpen}
                  setLoading={setLoading}
                  setAlertMessage={setAlertMessage}
                  initiativeDataPermissions={initiativeDataPermissions}
                />
              </div>
              <div
                className="company-dashboard-initiative-drawer-content-body-section-right-section-two"
                style={{ pointerEvents: initiativeId ? "auto" : "none" }}
              >
                <CompanyDashboardInitiativeMilestones
                  initiativeId={initiativeId}
                  initiativeAPIData={initiativeAPIData}
                  employeesList={employeesList}
                  fetchInitiativeById={fetchInitiativeById}
                  fetchInitiatives={fetchInitiatives}
                  setAlertType={setAlertType}
                  setAlertOpen={setAlertOpen}
                  setLoading={setLoading}
                  setAlertMessage={setAlertMessage}
                  keyResultId={keyResultId}
                  objectiveId={objectiveId}
                  statusListKeyResults={statusListKeyResults}
                  departmentsList={departmentsList}
                  milestonesData={milestonesData}
                  setMilestonesData={setMilestonesData}
                  initiativeDataPermissions={initiativeDataPermissions}
                  fetchUpcomingMilestones={fetchUpcomingMilestones}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyDashboardInitiativeAddDrawer;
